import './splide';
import './video';
// import './eventQueue';
// import './blazy';
// import './tables';
import './expanding-cards';
import './mobile-nav';
import './show-more';
import './views';
import './double-submit';
import './custom-accordion';
import './search-tags';
import './courses';
import './back-to-top';
import './ga-custom-events';
// import './bootstrap';
import '../../node_modules/jquery-once/jquery.once.min';

(function($, Drupal) {
  'use strict';
  // 9 times out of 10 it's probably better to make a new file
  // instead of writing code in here.

  // Set global variables, available in all components at runtime
  window.bp = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  };
})(jQuery, Drupal);
